import * as yup from 'yup'

export default yup.object().shape({
  itemId: yup
    .string()
    .min(1)
    .required('Required field'),
})
